export default __webpack_public_path__ + "static/media/Educ-Tecnologica.b3d93977.png";